import React from 'react'
import { TextField } from '@material-ui/core'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'

function TextArea(props) {
  let errorMessage = null
  let errorStatus = false
  const {
    type,
    input,
    label,
    placeholder,
    disabled,
    required,
    disableLabelMove,
    inputProps,
    onKeyUp,
    onKeyDown,
    meta: { submitError, touched, error },
  } = props

  if (touched && (error || submitError)) {
    errorStatus = true
    errorMessage = error || submitError
  }

  const keyboardProps = {}
  if (onKeyUp) keyboardProps.onKeyUp = onKeyUp
  if (onKeyDown) keyboardProps.onKeyDown = onKeyDown

  return (
    <div className="form-group">
      <FormControl component="div" fullWidth error={errorStatus}>
        <TextField
          {...input}
          {...inputProps}
          error={errorStatus}
          type={type}
          label={label}
          disabled={disabled}
          required={required}
          placeholder={placeholder}
          className="form-group"
          InputLabelProps={{ shrink: disableLabelMove }}
          inputProps={inputProps}
          {...keyboardProps}
          multiline
        />
        {errorStatus && <FormHelperText>{errorMessage}</FormHelperText>}
      </FormControl>
    </div>
  )
}

export default TextArea
